import { render, staticRenderFns } from "./FlashCard.vue?vue&type=template&id=65a7f145&scoped=true&"
import script from "./FlashCard.vue?vue&type=script&lang=ts&"
export * from "./FlashCard.vue?vue&type=script&lang=ts&"
import style0 from "./FlashCard.vue?vue&type=style&index=0&id=65a7f145&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a7f145",
  null
  
)

export default component.exports